import {
  isValidElement,
  type JSXElementConstructor,
  type ReactElement,
  type ReactNode,
} from 'react';

/** @internal */
export const isSlot = <T>(
  child: ReactNode,
  slotType: JSXElementConstructor<T>,
): child is ReactElement<T> => {
  return isValidElement(child) && child.type === slotType;
};
